import { SUITABILITY } from "@/config/layers-config.js";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  activeData: {
    scale: {},
    sector: {}
  },
  activeLayerGroup: "",
  marker: {
    lon: "0",
    lat: "0"
  },
  wmsLayerSuitability: {
    activeLayer: "",
    name: "",
    url: "",
    urlFuture: "",
    options: SUITABILITY.wmsOptions,
    identify: SUITABILITY.identify,
    hasFuture: false,
    visible: false
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
